export default {
  reset: {
    id: 'adminPanel.resetFilters',
    defaultMessage: 'Reset',
  },
};
